/* 🤖 this file was generated by svg-to-ts */
export const matIconLooks: {
  name: 'looks';
  data: string;
} = {
  name: 'looks',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"><path d="M12 10c-3.86 0-7 3.14-7 7h2c0-2.76 2.24-5 5-5s5 2.24 5 5h2c0-3.86-3.14-7-7-7zm0-4C5.93 6 1 10.93 1 17h2c0-4.96 4.04-9 9-9s9 4.04 9 9h2c0-6.07-4.93-11-11-11z"/></svg>`
};
